<template>
    <layout>       

        <template v-slot:username>
            <v-alert
                v-if="inActivity"
                text
                outlined
                color="deep-orange"
            >
                You have been signed out due to inactivity. Please sign back in to continue.
            </v-alert>
            <v-card-text>                                                
                <div class="primary--text text-h5 text-center">
                    Staff Portal                                                            
                </div>                                            
            </v-card-text>
            <v-form 
                class="pa-5"
                @submit.prevent
            >
                <v-text-field
                label="Username"
                placeholder="Enter username"
                name="id"                                                
                type="text"
                :color="icon_color"
                v-model="formData.name"
                clearable
                autofocus
                v-on:keyup="keyPress"
                >
                    <v-icon
                        slot="prepend"
                        :color="icon_color"
                    >
                        mdi-account
                    </v-icon>
                </v-text-field>

                <v-text-field
                    v-show="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :label="passwordLabel"
                    :placeholder="passwordPlaceholder"
                    :hint="passwordHint"
                    persistent-hint
                    @click:append="show = !show"                                                    
                    name="password"
                    v-model="formData.password"
                    clearable 
                    ref="password" 
                    @keydown.enter="submit"                  
                >
                    <v-icon
                        slot="prepend"
                        :color="icon_color"
                    >
                        mdi-key
                    </v-icon>
                </v-text-field>
            

                <div class="text-right mt-4  mb-4">
                    <v-btn 
                        color="primary" 
                        @click="submit" 
                        dark
                        block
                    >
                        LOGIN
                    </v-btn>
                </div>
            </v-form>
        </template>

        <template v-slot:password>
            <v-form 
                class="pa-5"
                @submit.prevent="submit"
            >
                <v-text-field
                    v-show="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :label="passwordLabel"
                    :placeholder="passwordPlaceholder"
                    :hint="passwordHint"
                    persistent-hint
                    @click:append="show = !show"                                                    
                    name="password"
                    v-model="formData.password"
                    clearable
                    autofocus
                >
                    <v-icon
                        slot="prepend"
                        :color="icon_color"
                    >
                        mdi-key
                    </v-icon>
                </v-text-field>
            

                <div class="text-right mt-4  mb-4">
                    <v-btn 
                        color="primary" 
                        @click="submit" 
                        dark
                        block
                    >
                        LOGIN
                    </v-btn>
                </div>
            </v-form>             
        </template>

    </layout>
</template>

<script>
import Layout from '../layouts/Login';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        passwordPlaceholder: 'Enter password',
        passwordLabel: 'Password',
        passwordHint: '',
        password: true,
    }),
    computed: {
        ...mapGetters({            
            primaryColor: 'termReports/getPrimaryColor',
            colorDarken: 'termReports/getColorDarken',
            step: 'auth/getStep',
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',  
            inActivity: 'auth/getInActivity',                       
        }),        
        icon_color(){
             return 'primary';
        },
        title_css(){
            return  'primary--text text-h5 text-left ';
        },
    },
    methods: {
        ...mapActions({
            signIn: 'auth/employeeSignIn',
            getUser: 'auth/user',          
        }),
        ...mapMutations({
            setLoginErrors: 'auth/setLoginErrors', 
            setStep: 'auth/setStep',
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setExpand: 'auth/setExpand',
            setInActivity: 'auth/setInActivity',
            setAuthenticated: 'auth/setAuthenticated',         
        }),
        async submit () {            
            console.log('Authenticating...');
            this.setUserName(this.formData.name);
            await this.signIn(this.formData);
            
            if(!this.authenticated){
                return;
            }   

            console.log('User Authenticated.');                
            //console.log(this.resetPassword);
            if(this.resetPassword){
                this.setAuthenticated(false);
                sessionStorage.authenticated = false;
                setTimeout(() => {this.setOverlay(false)});
                this.setStep(3);
                return;
            }
            
            this.setExpand(false);                                     
            setTimeout(() => {this.setOverlay(false)});                   
            this.$router.replace('/term-reports');
            

        },
       
        keyPress (e) {
            if(e.keyCode === 13) {
                this.$refs.password.focus();
            }
        },
        
    },
}
</script>